import driverService from "../../service/driver.service";

export const hasBankValue = (value) => Boolean(String(value ?? "").trim());

export const getMissingDriverBankFields = (dataBank = {}) => {
  const missing = [];
  if (!hasBankValue(dataBank?.pix)) {
    missing.push("Chave PIX");
  }
  if (!hasBankValue(dataBank?.holderAccount)) {
    missing.push("Nome do titular/recebedor do PIX");
  }
  return missing;
};

export const buildMissingBankFieldsMessage = (missingFields = []) => {
  if (!missingFields.length) {
    return "Para solicitar o pagamento, complete os dados bancários do motorista. Deseja editar o cadastro agora?";
  }

  return `Para solicitar o pagamento, complete os dados bancários do motorista: ${missingFields.join(
    " e ",
  )}. Deseja editar o cadastro agora?`;
};

export const getDriverEditPath = (firestoreId) =>
  firestoreId ? `/driverList/${firestoreId}` : "";

/**
 * No pagamento, `driverID` costuma ser o UID do motorista (não o id do doc).
 * Os dados bancários ficam em `drivers_users/{docId}/documents/allData.dataBank`.
 */
export const resolveDriverBankContext = async (paymentItem = {}) => {
  const candidateIds = [
    paymentItem?.driverDocId,
    paymentItem?.idDriver,
    paymentItem?.driverID,
    paymentItem?.driverId,
    typeof paymentItem === "string" ? paymentItem : null,
  ].filter((value, index, arr) => {
    if (!hasBankValue(value)) return false;
    return arr.indexOf(value) === index;
  });

  for (const candidate of candidateIds) {
    // 1) Tenta como ID do documento Firestore
    try {
      const allDataDoc = await driverService.getDriverAvailableById(candidate);
      if (allDataDoc?.exists) {
        return {
          firestoreId: candidate,
          dataBank: allDataDoc.data()?.dataBank || {},
        };
      }
    } catch (error) {
      // segue para fallback por UID
    }

    // 2) Tenta como UID de autenticação
    try {
      const byUid = await driverService.getDriverDocumentsUID(candidate);
      if (!byUid?.empty && byUid.docs?.[0]) {
        const driverDoc = byUid.docs[0];
        const allDataDoc = await driverDoc.ref
          .collection("documents")
          .doc("allData")
          .get();

        return {
          firestoreId: driverDoc.id,
          dataBank: allDataDoc?.exists
            ? allDataDoc.data()?.dataBank || {}
            : {},
        };
      }
    } catch (error) {
      // tenta próximo candidato
    }
  }

  return { firestoreId: "", dataBank: {} };
};

/**
 * Valida PIX + titular/recebedor para solicitação de pagamento.
 * @returns {{ ok: boolean, firestoreId: string, missingFields: string[], message: string }}
 */
export const validateDriverBankForPaymentRequest = async (paymentItem) => {
  if (!paymentItem) {
    return {
      ok: false,
      firestoreId: "",
      missingFields: [],
      message:
        "Não foi possível identificar o motorista para validar os dados bancários. Deseja editar o cadastro agora?",
    };
  }

  try {
    const { firestoreId, dataBank } = await resolveDriverBankContext(
      paymentItem,
    );
    const missingFields = getMissingDriverBankFields(dataBank);

    if (missingFields.length > 0) {
      return {
        ok: false,
        firestoreId: firestoreId || "",
        missingFields,
        message: buildMissingBankFieldsMessage(missingFields),
      };
    }

    return {
      ok: true,
      firestoreId: firestoreId || "",
      missingFields: [],
      message: "",
    };
  } catch (error) {
    console.error("Erro ao validar dados bancários do motorista:", error);
    return {
      ok: false,
      firestoreId: "",
      missingFields: [],
      message:
        "Não foi possível validar os dados bancários do motorista. Deseja editar o cadastro agora?",
    };
  }
};
